import {useLocation, useNavigate} from "react-router-dom";
import Page from "./layout/Page";
import Card from "./layout/Card";
import {ucwords} from "../utils";
import React, {useEffect} from "react";
import ContattoBtns from "./rubrica/ContattoBtns";
import Loader from "./layout/Loader";
import {getContent} from "../api";
import {fetchWithRetry, showError} from "../utils";

export default function ContattoInfo() {
    const location = useLocation();
    let { id } = location.state || {};

    let [contatto, setContatto] = React.useState(null);
    let [isLoading, setLoading] = React.useState(false);

    // Carica dati iniziali
    useEffect(() => {
        let ignore = false;
        const loadInitialData = async () => {
            setLoading(true);
            if (id) {
                // Carica il contatto
                const contattoData = await getContent("/contatto/id/" + id); 

                if (ignore) return; // Ignora se il componente è stato smontato

                setContatto({
                    ...contattoData?.contatto?.model,
                    cognome: contattoData?.contatto?.model?.lastname,
                    nome: contattoData?.contatto?.model?.firstname,
                    blocco: contattoData?.contatto?.model?.tipoblocco,
                    hanoteprerisposta: contattoData?.contatto?.model?.noteprerisposta &&
                                       contattoData?.contatto?.model?.noteprerisposta.trim() !== ""
                });
            }
        };
        

        fetchWithRetry(loadInitialData, ignore)
        .catch(err => {
            if (!ignore) {
                showError('Errore nel caricamento dati iniziali: ' + err.message);
            }
        })
        .finally(() => {
            if (!ignore) {
                setLoading(false);
            }
        });

        return () => {
            ignore = true; // Imposta ignore a true quando il componente viene smontato
        }
    }, []);
    


    if (isLoading) {
        return <Page title="Contatto">
                <Loader/>
            </Page>
    }

    if(!contatto){
        return (
            <Page title="Contatto">
                <Card title="Errore" content="Contatto non trovato" variant="error" />
            </Page>
        );
    }

    let cognomeLower = ucwords(contatto.cognome);
    let nomeLower = ucwords(contatto.nome);
    let contattoTitle = `${cognomeLower} ${nomeLower}`;
    
    return (
        <Page title="Contatto">
            <Card title={contattoTitle} content={contatto.numtel} variant="call-base-info" />
            <div style={{padding: '1rem'}}>
                <div className="vista-row-actions">
                    <ContattoBtns itemGroup={contatto} infoBtnTarget="delete" />
                </div>
            </div>
            <Card title="Azienda" content={contatto.azienda} />
            <Card title="Note Pre Risposta" content={contatto.noteprerisposta} />
        </Page>
    );
}